import { Document, FindAllOptions } from '../models/document';

import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<Document[]> {
    const url = this.common.constructPath(`/documents`, options);
    return this.common.getJSON(url);
  }

  downloadURL(id: string): string {
    return this.common.constructPath(`/documents/${id}/file`);
  }
}
